import { render, staticRenderFns } from "./PoliticaContratual.vue?vue&type=template&id=532584b6&"
import script from "./PoliticaContratual.vue?vue&type=script&lang=js&"
export * from "./PoliticaContratual.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports